@use "../../styles/breakpoint.module.scss" as *;

.root {
    padding-block: var(--spacer-80);
}

.singleChildRoot {
    composes: root;
    background-color: var(--light-beige);
}

.twoChildrenRoot {
    composes: root;

    .inner {
        @media ($below-mobile) {
            margin-inline: 0;
        }
    }

    @media ($below-tablet) {
        --labui-grid-gap: var(--spacer-32);
    }

    @media ($above-mobile) {
        background: linear-gradient(
            90deg,
            var(--white) 50%,
            var(--light-beige) 50%
        );
    }
}

.inner {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.formColumn {
    grid-column: 2 / span 4;

    @media ($below-tablet) {
        grid-column: span 6;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;

        .twoChildrenRoot & {
            margin-inline: var(--labui-container-margin);
        }
    }

    .singleChildRoot & {
        grid-column: 5 / span 4;

        @media ($below-tablet) {
            grid-column: 4 / span 6;
        }

        @media ($below-mobile) {
            grid-column: 1 / -1;
        }
    }
}

.contact {
    grid-column: 8 / span 4;

    @media ($below-tablet) {
        grid-column: span 6;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
        background: var(--light-beige);
        padding: var(--spacer-64) var(--labui-container-margin);
    }
}

.contactItem {
    display: flex;
    gap: var(--spacer-8);
    margin-top: var(--spacer-16);
}

.textLink {
    composes: fontTextLink from "../../styles/composable/typography.module.css";
    font: var(--font-p-16);

    @media ($above-mobile) {
        padding-top: 2px;
    }
}

.svg {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: var(--red);
    flex-shrink: 0;

    @media ($below-mobile) {
        margin-top: 3px;
    }
}

.title {
    font: var(--font-h-34);
}

.form {
    display: block;
    margin-block: var(--spacer-24);
}

.input {
    margin-block: var(--spacer-24);

    input {
        width: 100%;
        max-width: 400px;
    }
}

.legal {
    margin-block: var(--spacer-24);
    font: var(--font-p-14);
}

.submitContainer {
    margin-top: var(--spacer-24);
}

.contactLegalText {
    margin-top: var(--spacer-24);

    p {
        font: var(--font-p-14);
        line-height: 1.5;
    }
}
